// extracted by mini-css-extract-plugin
export default {"authForm":"c-b_cb"};